export default "__VITE_ASSET__607a3e02__"